import {createBrowserRouter} from 'react-router-dom'
import {PrivateRoute} from '@route-guards/private-route/PrivateRoute.tsx'
import {PublicRoute} from '@route-guards/public-route/PublicRoute.tsx'
import {PublicLayout} from '@layouts/public-layout/PublicLayout.tsx'
import {PrivateLayout} from '@layouts/private-layout/PrivateLayout.tsx'
import {UserRoleE, routes} from '@utilities/constants'
import RoleBasedRoute from './route-guards/role-based-route/RoleBasedRoute'
import {CommonLayout} from './layouts/common-layout/CommonLayout'
import {NotFound} from './pages/not-found/NotFound'
import QuoteWrapper from './pages/quote/QuoteWrapper'
import {ErrorBoundary} from './ErrorBoundary'
import SimplifiedQuoteWrapper from './pages/quote/SimplifiedQuoteWrapper'

const router = createBrowserRouter([
    {
        element: <PrivateRoute />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                element: <PrivateLayout />,
                children: [
                    {
                        element: <CommonLayout />,
                        children: [
                            {...routes.HOME},
                            {...routes.PROJECTS},
                            {...routes.PROJECT_DETAILS},
                            {...routes.SYSTEM_TEMPLATE},
                            {...routes.SYSTEM_CONFIGURATOR},
                            {...routes.CERBERO_CONFIGURATION},
                            {...routes.SERVICES},

                            {
                                element: <RoleBasedRoute grantedRoles={[UserRoleE.SUPPLIER, UserRoleE.RESELLER]} />,
                                children: [
                                    {...routes.PRODUCTS},
                                    {...routes.DISCOUNTS},
                                    {...routes.INSTALLERS},
                                    {...routes.INSTALLER_DETAILS},
                                    {...routes.INSTALLER_LIST},
                                    {...routes.RESELLER_INSTALLER_PROJECTS_LIST}
                                ]
                            },

                            {
                                element: <RoleBasedRoute grantedRoles={[UserRoleE.INSTALLER]} />,
                                children: [{...routes.INSTALLER_PRODUCTS}, {...routes.INSTALLER_DISCOUNTS}]
                            },
                            {
                                element: <RoleBasedRoute grantedRoles={[UserRoleE.SUPPLIER]} />,
                                children: [
                                    {...routes.RESELLERS},
                                    {...routes.RESELLER_DETAILS},
                                    {...routes.RESELLER_LIST},
                                    {...routes.RESELLER_PRODUCTS},
                                    {...routes.RESELLER_INSTALLERS}
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        element: <PublicRoute />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                element: <PublicLayout />,
                children: [
                    {...routes.LOGIN},
                    {...routes.PASSWORD_RECOVERY},
                    {...routes.RESET_PASSWORD},
                    {...routes.RESELLER_INVITATION},
                    {...routes.ACCESS_DENIED},
                    {...routes.INACTIVE_RESELLER}
                ]
            }
        ]
    },
    {
        path: routes.QUOTE.path,
        element: <QuoteWrapper />,
        errorElement: <ErrorBoundary />,
        handle: routes.QUOTE.handle
    },
    {
        path: routes.QUOTE_SIMPLIFIED.path,
        element: <SimplifiedQuoteWrapper />,
        errorElement: <ErrorBoundary />,
        handle: routes.QUOTE_SIMPLIFIED.handle
    },
    {...routes.INSTALLER_INVITATION},
    {path: '*', element: <NotFound />}
])

export default router
